export default {
    routerName: 'メニュー管理',
    name: 'メニュー一覧',
    menu: {
        frontEndName: 'フロントエンドショー',
        backEndName: 'バックエンド管理',
        menuName: 'メニュー名',
        icon: 'アイコン',
        url: 'URL',
        permit: '権限',
        sortOrder: 'ソート',
        type: 'タイプ',
        catalog: 'ディレクトリ',
        typeMenu: 'メニュー',
        typeButton: 'ボタン',
        status: '状態',
        statusOpen: '有効',
        statusClose: '無効',
    },
    table: {
        id: 'ID',
        menuName: 'メニュー名',
        icon: 'アイコン',
        url: 'リンク',
        permit: '権限',
        sortOrder: 'ソート',
        type: 'タイプ',
        status: '状態',
    },
    message: {
        delConfirmTitle: '削除警告',
        delIncludeSubNodeConfirm: 'すべての子ノードを削除しますか？',
        delConfirm: 'データを削除してもよろしいですか？',
    },
};
